import NormalButton from '@/components/items/Buttons/NormalButton'
import { commonUtil } from '@/util'
import { BigNumber } from 'bignumber.js'

export default {
  components: {
    NormalButton
  },
  props: {
    submitButtonName: { default: 'common.common_confirmation' },
    productListData: {
      type: Object,
      require: true,
      default: () => ({})
    },
    value: {
      type: Object,
      require: true,
      default: () => ({})
    },
    isRegister: { default: false },
    textColorFlag: { default: false }
  },
  data: () => ({}),
  methods: {
    submit() {
      this.$emit('submit')
    },

    getTaxFreeAmount(newVal) {
      return newVal
        .filter((ele) => ele.exportSubjectFlg)
        .reduce((result, current) => {
          return result + current.amount
        }, 0)
    },
    getTaxRateNum(id) {
      if (id === 8 || id === '8') {
        return 1
      }
      return 2
    },
    filterTaxAmount(newVal, taxValue) {
      return newVal
        .filter(
          (ele) =>
            !ele.exportSubjectFlg && ele.taxId === this.getTaxRateNum(taxValue)
        )
        .reduce((result, current) => {
          return result + current.amount
        }, 0)
    },
    getTax(num, taxPercentage) {
      return (num * taxPercentage) / 100
    },
    setData() {
      if (!this.isRegister) return

      const taxFree = this.getTaxFreeAmount(this.productListData.data)
      this.totalList.taxFree = taxFree

      const taxType = [10, 8]
      taxType.reduce((result, current) => {
        const amount = this.filterTaxAmount(this.productListData.data, current)

        let taxOnly

        taxOnly = this.productListData.isHistory
          ? this.totalList['tax' + current].tax
          : this.getTax(amount, current)

        this.totalList['tax' + current] = {
          totalAmount: amount,
          tax: taxOnly
        }
        return result + Number(amount) + Number(taxOnly)
      }, 0)
    },

    getTotalAmount() {
      return BigNumber(this.totalList.taxFree)
        .plus(Number(this.totalList.tax10.totalAmount))
        .plus(Number(this.totalList.tax10.tax * -1))
        .plus(Number(this.totalList.tax8.totalAmount))
        .plus(Number(this.totalList.tax8.tax * -1))
        .plus(Number(this.totalList.adjust * -1))
        .toNumber()
    },
    formatPrice(price) {
      return commonUtil.formatPrice(price)
    }
  },
  computed: {
    totalList: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    productListData: {
      deep: true,
      handler(newVal, oldVal) {
        this.setData()
      }
    }
    // 'totalList.discount': function (val) {
    //   this.setData(true)
    // },
    // 'totalList.shipping': function (val) {
    //   this.setData(true)
    // },
    // 'totalList.tax10.tax': function (val) {
    //   this.setData(true)
    // },
    // 'totalList.tax8.tax': function (val) {
    //   this.setData(true)
    // }
  }
}
